import { ActionTypes } from './constants';

export const showMap = () => ({
    type: ActionTypes.SHOW_MAP,
});
